import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { useBrokerAccountSetupFormHandlers } from '../../../hooks/useBrokerAccountSetupFormHandlers';
import { TextBox } from '@apply/components';

export const ClientFeeField: React.FC = () => {
    const clientFeeType = useBrokerDetailsStore((s) => s.clientFeeType);
    const { handleClientFeeTypeChange } = useBrokerAccountSetupFormHandlers();

    return (
        <TextBox
            id='clientFeeType'
            value={String(clientFeeType)}
            onChange={handleClientFeeTypeChange}
            label='Expected Client Fee %'
            helperText="Client Fee is money paid by B-Client to Broker. A Client Fee is an additional cost added to closing statement(s). Note that the BFI Share is money paid by BFI to Broker out of BFI's upfront points."
            width='100%'
        />
    );
};
